<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <Filter
                            :sns="false"
                            :resultType="false"
                            :resultDetailType="false"
                            :nation="false"
                            :isMonitoring="false"
                            :type="false"
                            :platform="true"
                            :selectOption="state.selectOption"
                            @search="filterSearch"
                            @reset="resetSearch"
                        ></Filter>

                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" />
                                </button>
                            </div>
                            <div class="count">
                                총
                                <span>{{ numberFormat(state.totalLength) }}건</span>
                            </div>
                        </div>

                        <div class="board_list no_filter">
                            <table class="board_table">
                                <colgroup>
                                    <col width="5%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="40%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="5%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>연번</th>
                                        <th>담당자</th>
                                        <th>플랫폼</th>
                                        <th>제목</th>
                                        <th>검색일시</th>
                                        <th>탐지건수</th>
                                        <th>상세보기</th>
                                        <th>삭제</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!state.isLoading">
                                    <tr v-for="(item, idx) in list.data">
                                        <td>{{ item.idx }}</td>
                                        <td>
                                            {{ item.uniqueName }}
                                        </td>
                                        <td>{{ item.platform }}</td>
                                        <td>
                                            <span :class="item.title.length > 30 ? 'more_txt' : ''" @click="moreText(item.title)">
                                                {{ item.title }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ formatDate(item.createDate) }}
                                        </td>
                                        <td>
                                            <div class="search_txt_box">
                                                <span class="total_count">
                                                    총
                                                    {{ item.cnt ? numberFormat(item.cnt) : 0 }}
                                                    건
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <button type="button" class="blue_btn" @click="resultBtn(item.idx)">탐지결과</button>
                                        </td>
                                        <td>
                                            <button type="button" class="delete_btn">
                                                <img src="@/assets/board/delete_ico.png" alt="" @click="remove(item.idx)" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="list.data.length === 0 && !state.isLoading">
                                    <tr>
                                        <td colspan="14">
                                            <NoResult></NoResult>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="state.isLoading">
                                    <tr>
                                        <td colspan="14">
                                            <Spinner></Spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <PageBtn
                            :currentPage="state.currentPage"
                            :totalLength="state.totalLength"
                            :perPage="state.perPage"
                            @onPaging="handlePageChange"
                        ></PageBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isPopupOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
</template>
<script lang="ts">
    import {
        Filter,
        globalStore,
        Header,
        Menu,
        onMounted,
        reactive,
        PageBtn,
        apiService,
        Popup,
        formatDate,
        numberFormat,
        dateFormat,
        NoResult,
        Spinner,
        router,
    } from "@/BaseComponent";

    interface List {
        idx: number;
        platform: string;
        title: string;
        uniqueName: string;
        slotNum: number;
        cnt: number;
        state: number;
        createDate: number;
    }
    export default {
        props: [],
        components: {
            Header,
            Menu,
            Filter,
            PageBtn,
            Popup,
            NoResult,
            Spinner,
        },
        setup() {
            const global = globalStore();

            const state = reactive({
                status: 1,
                checkAll: false as boolean,
                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 100 as number,
                totlapage: 1 as number,

                isPopupOpen: false,
                isLoading: false,

                selectOption: [
                    { idx: 2, text: "제목", key: 1 },
                    { idx: 3, text: "담당자", key: 3 },
                ],
                filterData: {} as any,
            });
            const list = reactive({
                data: [] as List[],
            });

            const modal = reactive({
                title: "" as string,
                content: {
                    title: "",
                    main: {
                        data: "" as any,
                        class: "desc",
                        render: (data: any) => {
                            return `<p>${data}</p>`;
                        },
                    },
                    subTitle: "",
                    sub: {
                        title: "",
                        data: "",
                        render: (data: any) => {
                            return `<p>${data}</p>`;
                        },
                    },
                } as any,
            });

            onMounted(() => {
                global.setSelectMenu(6);
            });

            const getList = async () => {
                state.isLoading = true;
                const searchType = state.selectOption.find((item) => item.idx === state.filterData?.searchType)?.key;
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    type: state.status === 1 ? "" : state.status.toString(),
                    startDate: state.filterData ? dateFormat(new Date(state.filterData.date[0])) : "",
                    endDate: state.filterData ? dateFormat(new Date(state.filterData.date[1])) : "",
                    searchType,
                    searchContent: state.filterData ? state.filterData.searchContent : "",
                    platform: state.filterData ? state.filterData.platform : [],
                };
                const res = await apiService.ai.getRoomList(param);
                if (res.returnCode === 0) {
                    list.data = res.list.data;
                    state.totlapage = res.list.totlapage;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    list.data = [];
                }
                state.isLoading = false;
            };

            const remove = async (idx: number) => {
                if (confirm("채팅방 목록을 삭제하시겠습니까?")) {
                    const res = await apiService.ai.removeForRoom(idx);
                    if (res.returnCode === 0) {
                        alert("삭제 완료되었습니다.");
                        getList();
                    } else {
                        alert("삭제 실패했습니다.\n사유 : " + res.description);
                    }
                }
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getList();
            };

            const modalClose = () => {
                state.isPopupOpen = false;
            };

            const resultBtn = (idx: number) => {
                router.push("/ai/watcher_bot/result/" + idx);
            };

            const moreText = (keyword: string) => {
                if (keyword.length > 30) {
                    modal.title = "검색키워드";
                    modal.content.title = "";
                    modal.content.main.data = keyword;
                    modal.content.subTitle = "";
                    state.isPopupOpen = true;
                }
            };

            const filterSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getList();
            };

            const resetSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getList();
            };

            const excelDownLoad = async () => {
                const searchType = state.selectOption.find((item) => item.idx === state.filterData?.searchType)?.key;
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    type: state.status === 1 ? "" : state.status.toString(),
                    startDate: state.filterData ? dateFormat(new Date(state.filterData.date[0])) : "",
                    endDate: state.filterData ? dateFormat(new Date(state.filterData.date[1])) : "",
                    searchType,
                    searchContent: state.filterData ? state.filterData.searchContent : "",
                    platform: state.filterData ? state.filterData.platform : [],
                };
                const res: any = await apiService.ai.downExcel(param);

                if (res.status === 200) {
                    try {
                        const blob = res.data;
                        const fileUrl = URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.download = `탐지결과_리스트_${param.startDate}${param.endDate}.xlsx`;
                        link.href = fileUrl;
                        link.click();
                        URL.revokeObjectURL(fileUrl);
                        return alert("다운로드 완료 되었습니다.");
                    } catch (error) {
                        return alert("다운로드에 실패했습니다.");
                    }
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            return {
                state,
                list,

                modal,
                formatDate,
                numberFormat,
                remove,
                handlePageChange,
                modalClose,
                getList,
                resultBtn,
                moreText,
                resetSearch,
                filterSearch,
                excelDownLoad,
            };
        },
    };
</script>
